<div class="sharing-setup">
  <!-- Progress Indicator / Stepper -->
  <div *ngIf="!isImageShareMode" class="progress-indicator">
    <div class="progress-steps">
      <div
        *ngFor="let step of progressSteps; let i = index"
        class="progress-step"
        [class.active]="currentPage === step.number"
        [class.completed]="currentPage > step.number">
        <div class="progress-step-number">{{ step.number }}</div>
        <div class="progress-step-label">{{ step.label }}</div>
      </div>
    </div>
  </div>

  <!-- Animated facility boxes with arrow animation - Shown on step 4 -->
  <app-facility-animation
    *ngIf="showFacilityAnimation && currentPage === 4"
    [origin]="currentFacilityName"
    [target]="targetFacilityName"
    [action]="shareDirection === 'send' ? 'SEND' : (shareDirection === 'receive' ? 'RETRIEVE' : 'SEND')">
  </app-facility-animation>

  <!-- Animated facility boxes with arrow animation - Shown on other steps -->
  <app-facility-animation
    *ngIf="showFacilityAnimation && currentPage !== 4"
    [origin]="currentFacilityName"
    [target]="targetFacilityName"
    [action]="shareDirection === 'send' ? 'SEND' : (shareDirection === 'receive' ? 'RETRIEVE' : 'SEND')">
  </app-facility-animation>

  <!-- Exchange Parameters Section - Shown on step 4 -->
  <div *ngIf="currentPage === 4 && (selectedTargetFacility || shareTypeSelected || shareDirection)" 
       class="exchange-parameters-section">
    <div class="exchange-parameters-list">
      <div *ngIf="selectedTargetFacility" class="exchange-parameter">
        <span class="exchange-parameter-label">TARGET FACILITY:</span>
        <span class="exchange-parameter-value">{{ selectedTargetFacilityName }}</span>
        <button
          type="button"
          class="exchange-parameter-edit"
          mat-icon-button
          aria-label="Edit target facility"
          (click)="onEditTargetFacility()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      <div *ngIf="selectedFacilityUsersDisplay.length > 0" class="exchange-parameter">
        <span class="exchange-parameter-label">SELECTED USERS:</span>
        <div class="exchange-parameter-users">
          <span
            *ngFor="let u of selectedFacilityUsersDisplay; trackBy: trackBySelectedUserChip"
            class="exchange-user-chip">
            {{ u.label }}
          </span>
        </div>
        <button
          type="button"
          class="exchange-parameter-edit"
          mat-icon-button
          aria-label="Edit selected users"
          (click)="onEditSelectedUsers()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      <div *ngIf="shareTypeSelected" class="exchange-parameter">
        <span class="exchange-parameter-label">TYPE:</span>
        <span class="exchange-parameter-value">
          {{ shareTypeSelected === 'image' ? 'IMAGE' : 'DOCUMENT' }}
        </span>
        <button
          type="button"
          class="exchange-parameter-edit"
          mat-icon-button
          aria-label="Edit type of exchange"
          (click)="onEditShareType()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      <div *ngIf="shareDirection" class="exchange-parameter exchange-parameter--direction">
        <mat-icon class="exchange-parameter-direction-icon">{{ shareDirection === 'send' ? 'play_arrow' : 'download' }}</mat-icon>
        <span class="exchange-parameter-label">DIRECTION:</span>
        <span class="exchange-parameter-value exchange-parameter-value--direction">
          {{ shareDirection === 'send' ? 'SEND' : 'RETRIEVE' }}
        </span>
        <button
          type="button"
          class="exchange-parameter-edit"
          mat-icon-button
          aria-label="Edit direction"
          (click)="onEditDirection()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Selection summaries - Shown on other steps -->
  <div *ngIf="currentPage !== 4" class="selection-summaries-container">
    <div
      *ngIf="selectedTargetFacility"
      class="selection-summary selection-summary--facility">
      <div class="selection-summary__content">
        <mat-icon class="selection-summary__label-icon">business</mat-icon>
        <span class="selection-summary__label">Target facility:</span>
        <span class="selection-summary__value">{{ selectedTargetFacilityName }}</span>
      </div>
      <button
        type="button"
        class="selection-summary__edit"
        mat-icon-button
        aria-label="Edit target facility"
        (click)="onEditTargetFacility()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <!-- Selected users summary -->
    <div
      *ngIf="selectedFacilityUsersDisplay.length > 0"
      class="selection-summary selection-summary--users">
      <div class="selection-summary__content">
        <mat-icon class="selection-summary__label-icon">people</mat-icon>
        <span class="selection-summary__label">Selected users:</span>
        <div class="selected-users-chips">
          <span
            *ngFor="let u of selectedFacilityUsersDisplay; trackBy: trackBySelectedUserChip"
            class="chip">
            {{ u.label }}
          </span>
        </div>
      </div>
      <button
        type="button"
        class="selection-summary__edit"
        mat-icon-button
        aria-label="Edit selected users"
        (click)="onEditSelectedUsers()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <div
      *ngIf="shareTypeSelected"
      class="selection-summary selection-summary--type">
      <div class="selection-summary__content">
        <mat-icon class="selection-summary__label-icon">swap_horiz</mat-icon>
        <span class="selection-summary__label">Type:</span>
        <span class="selection-summary__value">
          {{ shareTypeSelected === 'image' ? 'IMAGE' : 'DOCUMENT' }}
        </span>
      </div>
      <button
        type="button"
        class="selection-summary__edit"
        mat-icon-button
        aria-label="Edit type of exchange"
        (click)="onEditShareType()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <div
      *ngIf="shareDirection"
      class="selection-summary selection-summary--direction">
      <div class="selection-summary__content">
        <mat-icon class="selection-summary__label-icon">{{ shareDirection === 'send' ? 'send' : 'download' }}</mat-icon>
        <span class="selection-summary__label">Direction:</span>
        <span class="selection-summary__value">
          {{ shareDirection === 'send' ? 'SEND' : 'RETRIEVE' }}
        </span>
      </div>
      <button
        type="button"
        class="selection-summary__edit"
        mat-icon-button
        aria-label="Edit direction"
        (click)="onEditDirection()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>

  <div
    *ngIf="!(isImageShareMode && currentPage === 4)"
    class="step-header">
    <h2 class="step-title">{{ stepMessage }}</h2>
    <p *ngIf="stepSubtitle" class="step-subtitle">{{ stepSubtitle }}</p>
  </div>

  <ng-container [ngSwitch]="currentPage">
    <!-- Step 1: Select a target facility -->
    <ng-container *ngSwitchCase="1">
      <div *ngIf="facilities?.length > 0; else noFacilities" class="facility-selection">
        <!-- Search Bar for Facilities -->
        <div class="facility-search-container">
          <mat-form-field appearance="outline" class="facility-search-field">
            <mat-label>Search facilities...</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="facilitySearchQuery"
              (ngModelChange)="onFacilitySearchChange()">
            <mat-hint>Search by name, city or ID</mat-hint>
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="facility-cards-grid">
          <app-patient-id-card
            *ngFor="let facility of filteredFacilities; trackBy: trackByFacilityId"
            [facility]="facility"
            [clickable]="true"
            [showClickHint]="true"
            [selected]="isSelected({ facility: facility.id, value: '', ownerId: '' })"
            (click)="onFacilitySelected({ facility: facility.id, value: '', ownerId: '' })">
          </app-patient-id-card>
        </div>
        <button
          *ngIf="false"
          class="add-target-facility-button"
          type="button"
          (click)="onAddTargetFacility()">
          <div class="facility-info">
            <span class="facility-label"> Facility </span>
            <span class="facility-name"> Add a target facility </span>
          </div>
          <div class="patient-id-info">
            <span class="id-label"> Action </span>
            <span class="id-value"> Create new </span>
          </div>
          <mat-icon class="add-icon"> add_circle </mat-icon>
        </button>
        <!-- Navigation Buttons -->
        <div class="step-navigation">
          <button
            class="nav-button nav-button--cancel"
            type="button"
            mat-button
            (click)="onCancelExchange()">
            Cancel Exchange
          </button>
          <button
            *ngIf="shouldShowContinueButton"
            class="nav-button nav-button--next"
            type="button"
            mat-raised-button
            (click)="onContinueFromStep1()">
            Next Step
            <mat-icon> arrow_forward </mat-icon>
          </button>
        </div>
      </div>

      <ng-template #noFacilities>
        <div class="no-facilities">
          <mat-icon class="info-icon"> info </mat-icon>
          <div class="no-facilities-content">
            <h3 class="no-facilities-title">No Facilities Available</h3>
            <p class="no-facilities-message">
              This patient hasn't been shared with any facilities yet, or there are no other facilities available to share with.
            </p>
            <p class="no-facilities-help">
              Please contact your administrator if you believe this is an error, or check that the patient has been properly shared with hub facilities.
            </p>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- Step 2: Select a type of sharing (DOCUMENT SHARE or IMAGE SHARE) - moved from step 3 -->
    <ng-container *ngSwitchCase="2">
      <div class="share-buttons-section">
        <app-share-button
          title="DOCUMENT"
          extraClasses="document-share"
          icon="description"
          subtitle="Patient Profile"
          (pressed)="onDocumentShare()">
        </app-share-button>

        <app-share-button
          title="IMAGE"
          extraClasses="image-share"
          icon="image"
          subtitle="Medical images"
          (pressed)="onImageShare()">
        </app-share-button>
      </div>
      <!-- Navigation Buttons -->
      <div class="step-navigation">
        <button
          class="nav-button nav-button--cancel"
          type="button"
          mat-button
          (click)="onCancelExchange()">
          Cancel Exchange
        </button>
        <button
          class="nav-button nav-button--back"
          type="button"
          mat-button
          (click)="onGoBack()">
          Back
        </button>
        <button
          *ngIf="shareTypeSelected"
          class="nav-button nav-button--next"
          type="button"
          mat-raised-button
          (click)="onContinueToNextStep()">
          Next Step
          <mat-icon> arrow_forward </mat-icon>
        </button>
      </div>
    </ng-container>

    <!-- Step 3: Select between SEND and RETRIEVE (moved from step 4) -->
    <ng-container *ngSwitchCase="3">
      <div
        *ngIf="!isImageShareMode"
        class="share-buttons-section">
        <app-share-button
          title="SEND"
          extraClasses="send-direction"
          icon="send"
          subtitle="Send data to facility"
          (pressed)="onSendSelected()">
        </app-share-button>

        <app-share-button
          title="RETRIEVE"
          extraClasses="receive-direction"
          icon="download"
          subtitle="Retrieve from facility"
          (pressed)="onReceiveSelected()">
        </app-share-button>
      </div>
      <!-- Navigation Buttons -->
      <div class="step-navigation">
        <button
          class="nav-button nav-button--cancel"
          type="button"
          mat-button
          (click)="onCancelExchange()">
          Cancel Exchange
        </button>
        <button
          class="nav-button nav-button--back"
          type="button"
          mat-button
          (click)="onGoBack()">
          Back
        </button>
        <button
          *ngIf="shareDirection"
          class="nav-button nav-button--next"
          type="button"
          mat-raised-button
          (click)="onContinueToNextStep()">
          Next Step
          <mat-icon> arrow_forward </mat-icon>
        </button>
      </div>
    </ng-container>

    <!-- Step 4: Select facility users (moved from step 2, only shown for image + send) -->
    <ng-container *ngSwitchCase="4">
      <div
        *ngIf="shareTypeSelected === 'image' && shareDirection === 'send'; else skipUsersStep"
        class="facility-user-selection">
        <div class="facility-user-selection-header">
          <h3 class="facility-user-selection-title">Select facility users</h3>
          <p class="facility-user-selection-subtitle">
            Choose one or more users to receive the images at {{ targetFacilityName }}.
          </p>
        </div>
        <div *ngIf="availableUsers?.length; else noUsers">
          <!-- Search Bar -->
          <div class="user-search-container">
            <mat-form-field appearance="outline" class="user-search-field">
              <mat-label>Search users...</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="userSearchQuery"
                (ngModelChange)="onUserSearchChange()">
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
          </div>
          <div class="user-list">
            <button
              *ngFor="let user of filteredUsers; trackBy: trackByUserId"
              class="user-option"
              type="button"
              [class.selected]="isUserSelected(user)"
              (click)="onFacilityUserSelected(user)">
              <div class="user-avatar" [class.user-avatar--selected]="isUserSelected(user)">
                {{ getUserInitials(user) }}
              </div>
              <div class="user-info">
                <div class="user-name">
                  {{ user.name }}
                </div>
                <div class="user-email">
                  {{ user.email }}
                </div>
                <div
                  *ngIf="user.role"
                  class="user-role-tag"
                  [class.user-role-tag--facility]="getRoleLabel(user.role) === 'Facility user'">
                  {{ getRoleLabel(user.role).toUpperCase() }}
                </div>
              </div>
              <mat-icon
                *ngIf="isUserSelected(user)"
                class="check-icon">
                check_circle
              </mat-icon>
            </button>
          </div>
          <!-- Navigation Buttons -->
          <div class="step-navigation step-navigation--step4">
            <div class="nav-buttons-left">
              <button
                class="nav-button nav-button--cancel"
                type="button"
                mat-button
                (click)="onCancelExchange()">
                Cancel Exchange
              </button>
              <button
                class="nav-button nav-button--back"
                type="button"
                mat-button
                (click)="onGoBack()">
                Back
              </button>
            </div>
            <!-- Pager in the middle -->
            <app-pager-setup
              *ngIf="!isImageShareMode"
              class="pager-inline"
              [currentPage]="currentPage"
              [totalPages]="totalPages"
              (pageChange)="onPageChange($event)">
            </app-pager-setup>
            <button
              *ngIf="selectedFacilityUsers.length > 0"
              class="nav-button nav-button--next nav-button--primary"
              type="button"
              mat-raised-button
              (click)="onContinueToNextStep()">
              Continue
              <mat-icon> arrow_forward </mat-icon>
            </button>
          </div>
        </div>

        <ng-template #noUsers>
          <div class="no-users-message">
            <mat-icon> info </mat-icon>
            <span> No users available for the selected facility. </span>
          </div>
        </ng-template>
      </div>

      <ng-template #skipUsersStep>
        <!-- This step is skipped for document share or image receive -->
        <!-- The parent component will handle navigation -->
      </ng-template>
    </ng-container>
  </ng-container>

  <app-pager-setup
    *ngIf="!isImageShareMode && currentPage !== 4"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    (pageChange)="onPageChange($event)">
  </app-pager-setup>
</div>
